import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import styled from "styled-components";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DraggableMetric from './DraggableMetric';
import { PrimaryButton, SecondaryButton, ButtonSizeOptions } from '@loanbossinc/component-library';

const StyledPrimaryButton = styled(PrimaryButton)`&&&{
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 24px;
}`;

const StyledSecondaryButton = styled(SecondaryButton)`&&&{
  margin-top: 16px;
  margin-left: 24px;
  margin-bottom: 24px;
}`;

class OrderMetricsStep extends React.Component {


  // save current state even before a drag event occurs.
  componentDidMount() {
    const currentMetrics = [...this.props.metrics];
    currentMetrics.filter(x => x.isSelected).sort(this.sortOnLayoutOrder).forEach((el, i, arr) => {
      el.layoutOrder = i;
    });

    this.props.updateMetrics(currentMetrics);
  }

  onDragEnd = (result) => {
    const copiedMetrics = [...this.props.metrics];
    let orderedMetrics = this.reorderMetrics(copiedMetrics, result);
    this.updateLayoutOrder(copiedMetrics, orderedMetrics);
    this.props.updateMetrics(copiedMetrics);
  }

  //update the overarching metric list with the mutated subset of selected,ordered metrics
  updateLayoutOrder = (copiedMetrics, orderedMetrics) => {
    for (let i = 0; i < copiedMetrics.length; i++) {
      let match = orderedMetrics.find(x => x.screenElementId === copiedMetrics[i].screenElementId);
      if (match) {
        copiedMetrics[i].layoutOrder = match.layoutOrder;
      }
    }
  }

  //simulate the same user action with pure data via array splice using the source and destination indexes.
  //This will give the same layout order that we assign to the subset array of metrics
  reorderMetrics = (copiedMetrics, result) => {

    let el = copiedMetrics.find(x => x.screenElementId === result.draggableId);
    let orderedMetrics = copiedMetrics.filter(x => x.isSelected).sort(this.sortOnLayoutOrder);

    orderedMetrics.splice(result.source.index, 1);
    orderedMetrics.splice(result.destination.index, 0, el);

    for (let i = 0; i < orderedMetrics.length; i++) {
      orderedMetrics[i].layoutOrder = i;
    }

    return orderedMetrics;
  }

  sortOnLayoutOrder = (a, b) => {
    if (a.layoutOrder < b.layoutOrder)
      return -1;
    if (a.layoutOrder > b.layoutOrder)
      return 1;
    return 0;
  }

  render() {
    const { metrics, activeStep, handleClose, handleBack, handleSave } = this.props;
    let selectedMetrics = metrics.filter(x => x.isSelected);
    return (
      <Fragment>
        <DialogContent>
          <DragDropContext onDragEnd={this.onDragEnd} >
            <Droppable droppableId='orderMetricsDroppableId'>
              {(provided) => {
                return (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}>
                    {selectedMetrics.sort(this.sortOnLayoutOrder).map((x, index) => <DraggableMetric key={x.screenElementId} metric={x} index={index} id={"draggableItem" + x.screenElementId} />)}
                    {provided.placeholder}
                  </div>
                )
              }
              }
            </Droppable>
          </DragDropContext>
        </DialogContent>
        <DialogActions>
          <Fragment>
            <StyledSecondaryButton label="Cancel" size={ButtonSizeOptions.sm} onClick={handleClose} />
            <StyledSecondaryButton label="Back" size={ButtonSizeOptions.sm} onClick={handleBack(activeStep)} />
            <StyledPrimaryButton label="Save" size={ButtonSizeOptions.sm} onClick={handleSave} />
          </Fragment>
        </DialogActions>
      </Fragment>
    );
  }
}

export default OrderMetricsStep;
